const transactionTypeOptions = [
  { key: 'PURCHASE', text: 'Purchase' },
  { key: 'DEPOSIT', text: 'Deposit' },
  { key: 'CASH', text: 'Cash' },
  { key: 'PURCHASE_WITH_CASH_DISBURSEMENT', text: 'Purchase With Cash Disbursement' },
  { key: 'QUASI_CASH', text: 'Quasi Cash'},
  { key: 'RETURN', text: 'Return' },
  { key: 'PAYMENT_RETURN', text: 'Payment Return' },
  { key: 'PAYMENT_TO_THIRD_PARTY', text: 'Payment To Third Party' },
  { key: 'PAYMENT_FROM_THIRD_PARTY', text: 'Payment From Third Party' },
  { key: 'PAYMENT_DEBIT', text: 'Payment Debit' },
  { key: 'PAYMENT_CREDIT', text: 'Payment Credit' },
  { key: 'CREDIT_ADJUSTMENT', text: 'Credit Adjustment'},
  { key: 'DEBIT_ADJUSTMENT', text: 'Debit Adjustment' },
  { key: 'CARDHOLDER_ACCOUNTS_TRANSFER', text: 'Cardholder Accounts Transfer'},
];

export default transactionTypeOptions;